<template>
  <section>
    <div class="mb-4">
      <h2 class="text-h6">{{ $t("ncrm.integrations.mailjet.privacy.title") }}</h2>
      <p class="text-body-2 text-medium-emphasis mb-0">{{ $t("ncrm.integrations.mailjet.privacy.subtitle") }}</p>
    </div>
    <v-alert v-if="loadError" type="error" class="mb-4">
      {{ loadError }}
      <template #append><v-btn variant="text" @click="fetchAccounts">{{ $t("ncrm.integrations.mailjet.privacy.retry") }}</v-btn></template>
    </v-alert>
    <v-skeleton-loader v-if="loading" type="list-item" />
    <div v-else-if="!accounts.length && !loadError">
      <v-alert type="info" class="mb-4">{{ $t("ncrm.integrations.mailjet.privacy.noAccounts") }}</v-alert>
      <NcrmMailjetTemplatesTab purpose-only privacy-only />
    </div>
    <template v-else-if="accounts.length">
      <v-select v-model="selectedAccountId" :items="accounts" item-title="name" item-value="id"
        :label="$t('ncrm.integrations.mailjet.privacy.account')"
        class="mb-4" hide-details />
      <!-- S8.2b: sub-vederi ale aceluiași workspace (șabloane / liste), deci segmented control, nu tab-uri de pagină. -->
      <NcrmSegmentedControl v-model="view" :items="viewItems" class="mb-4"
        :aria-label="$t('ncrm.integrations.mailjet.privacy.views.ariaLabel')" />
      <NcrmMailjetListPurposesTab v-if="view === 'lists'" :key="`lists-${selectedAccountId}`" :account-id="selectedAccountId" />
      <NcrmMailjetTemplatesTab v-else :key="selectedAccountId" :account-id="selectedAccountId" privacy-only />
    </template>
  </section>
</template>
<script>
import axios from "axios";
import NcrmSegmentedControl from "@/components/ncrm/shared/NcrmSegmentedControl.vue";
import NcrmMailjetListPurposesTab from "./NcrmMailjetListPurposesTab.vue";
import NcrmMailjetTemplatesTab from "./NcrmMailjetTemplatesTab.vue";
export default {
  name: "NcrmMailjetPrivacyWorkspace",
  components: { NcrmMailjetListPurposesTab, NcrmMailjetTemplatesTab, NcrmSegmentedControl },
  // The sub-view lives in the URL (`mailjetView`) so the purposes link returns to it (docs/design.md → întoarcere în context).
  data() {
    return { accounts: [], selectedAccountId: null, loading: false, loadError: "",
      view: this.$route?.query?.mailjetView === "lists" ? "lists" : "templates" };
  },
  watch: {
    view(value) { this.$router?.replace({ query: { ...this.$route.query, mailjetView: value } }).catch(() => {}); },
  },
  computed: {
    viewItems() {
      return [
        { value: "templates", label: this.$t("ncrm.integrations.mailjet.privacy.views.templates"), icon: "mdi-email-edit-outline" },
        { value: "lists", label: this.$t("ncrm.integrations.mailjet.privacy.views.lists"), icon: "mdi-format-list-bulleted" },
      ];
    },
  },
  mounted() { this.fetchAccounts(); },
  methods: {
    async fetchAccounts() {
      this.loading = true;
      this.loadError = "";
      try {
        const { data } = await axios.get("/ncrm/privacy/configuration/email-accounts");
        this.accounts = Array.isArray(data?.accounts) ? data.accounts : [];
        if (!this.accounts.some(({ id }) => id === this.selectedAccountId)) {
          this.selectedAccountId = this.accounts[0]?.id || null;
        }
      } catch (error) {
        this.loadError = error?.response?.data?.error || error?.message ||
          this.$t("ncrm.integrations.mailjet.privacy.accountsError");
      } finally { this.loading = false; }
    },
  },
};
</script>
